const clientTypes = [
  { label: 'Корпоративный', value: 'corporate' },
  { label: 'Физический', value: 'individual' },
];

export default clientTypes;